export default __webpack_public_path__ + "static/media/portfolio-hover-164.5cf578b6.jpg";